<template>
  <div>
    <base-header class="pb-6" type="indigo">
      <b-row align-v="center" class="py-4">
        <b-col lg="6" cols="7">
          <h6 class="h2 text-white d-inline-block mb-0">Create Document</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <loading
        :active.sync="loading"
        :can-cancel="false"
        :is-full-page="true"
      ></loading>

      <b-row v-if="!loading && company">
        <b-col cols="12" lg="10" xl="8" offset="0" offset-lg="1" offset-xl="2">
          <b-card>
            <b-card-header>
              <h3 class="h3 mb-0">
                New Document for {{ company.name }}
              </h3></b-card-header
            >
            <validation-observer v-slot="{ valid, handleSubmit }">
              <b-form
                role="form"
                @submit.prevent="handleSubmit(createDocument)"
              >
                <b-card-body>
                  <!-- Basic fields -->
                  <b-row class="border-bottom pb-3">
                    <b-col cols="12" sm="4">
                      <h4 class="display-4 uppercase">Document</h4>
                      <p class="text-muted">
                        Annual Returns for Isle of Man 1931 Act Companies
                        (limited by shares) are currently supported.
                      </p>
                    </b-col>
                    <b-col cols="12" sm="7" offset-sm="1">
                      <b-row>
                        <b-col cols="12">
                          <base-input label="Document" name="Document">
                            <select class="form-control" v-model="type">
                              <option
                                value="iom_1931_act_limited_by_shares_annual_return"
                              >
                                Annual Return for 1931 Act Company (Limited by
                                Shares)
                              </option>
                            </select>
                          </base-input>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col cols="12" md="6">
                          <base-input
                            label="Filing Due By"
                            name="Due Date"
                            type="date"
                            v-model="filingDueDate"
                          ></base-input>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-row
                    class="border-bottom py-3"
                    v-if="
                      type === 'iom_1931_act_limited_by_shares_annual_return'
                    "
                  >
                    <b-col cols="12" sm="4">
                      <h4 class="display-4 uppercase">Presentation</h4>
                      <p class="text-muted">
                        Who is signing and presenting this document?
                      </p>
                    </b-col>
                    <b-col cols="12" sm="7" offset-sm="1">
                      <b-row>
                        <b-col>
                          <find-or-create-contact-form
                            ref="findOrCreateContactForm"
                            search-label="Signatory name"
                            v-model="signatoryId"
                            :accountId="account.id"
                            :preset-contact="signatoryPresetContact"
                          ></find-or-create-contact-form>
                        </b-col>
                        <b-col>
                          <base-input
                            label="Signatory role"
                            name="Signatory role"
                            :rules="{ required: true }"
                            :debounce="500"
                            placeholder="e.g. Director"
                            v-model="signatoryRole"
                          ></base-input>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col sm="6">
                          <base-input
                            label="Presenter name"
                            name="Presenter name"
                            :rules="{ required: true }"
                            :debounce="500"
                            placeholder="e.g. The Company"
                            v-model="presenterName"
                          ></base-input>
                        </b-col>

                        <b-col sm="6">
                          <base-input
                            label="Signing date"
                            name="Signing date"
                            type="date"
                            v-model="signingDate"
                          ></base-input>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <!-- address -->
                          <base-input
                            label="Presenter Address"
                            name="Address"
                            :rules="{ required: true }"
                            :debounce="500"
                            placeholder="e.g. 12 Marine Drive, Douglas, IM8 XE1"
                            v-model="presenterAddress"
                          ></base-input>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-row
                    class="border-bottom py-3"
                    v-if="
                      type === 'iom_1931_act_limited_by_shares_annual_return'
                    "
                  >
                    <b-col cols="12" sm="4">
                      <h4 class="display-4 uppercase">Details</h4>
                      <p class="text-muted">
                        This information is used to complete the filing.
                      </p>
                    </b-col>
                    <b-col cols="12" sm="7" offset-sm="1">
                      <b-row>
                        <b-col sm="6">
                          <base-input
                            label="Return date"
                            name="Return date"
                            type="date"
                            v-model="returnDate"
                          ></base-input>
                        </b-col>
                      </b-row>

                      <hr />

                      <!-- Accounts prepared? -->
                      <b-row class="mb-2">
                        <b-col cols="10">
                          <label class="form-control-label align-bottom"
                            >Has the company prepared financial statements?</label
                          >
                        </b-col>
                        <b-col cols="2">
                          <base-switch
                            class="mr-1"
                            v-model="financialStatementsPrepared"
                          ></base-switch>
                        </b-col>
                      </b-row>

                      <!-- Financial statements not prepared as not required since incorporation? -->
                      <b-row class="mb-2" v-if="!financialStatementsPrepared">
                        <b-col cols="10">
                          <label class="form-control-label align-bottom">
                            The company has not been required to prepare its first set of financial
                            statements since incorporation.
                          </label>
                        </b-col>
                        <b-col cols="2" class="text-center">
                          <b-form-checkbox
                            id="financial-statements-not-required-since-incorporation"
                            v-model="financialStatementsNotRequiredSinceIncorporation"
                            name="financial-statements-not-required-since-incorporation"
                          >
                          &nbsp;
                          </b-form-checkbox>
                        </b-col>
                      </b-row>

                      <!-- Financial statements prepared until date -->
                      <b-row class="mb-2" v-if="financialStatementsPrepared">
                        <b-col cols="6">
                          <label class="form-control-label align-bottom"
                            >Financial statements prepared up to</label
                          >
                        </b-col>
                        <b-col cols="6">
                          <base-input
                            name="Financial statements prepared to date"
                            type="date"
                            v-model="financialStatementsPreparedUntil"
                          ></base-input>
                        </b-col>
                      </b-row>

                      <hr />

                      <label class="form-control-label"
                            >Accounting records</label
                          >

                      <b-row>
                        <b-col cols="4" class="text-left">
                          The company has
                        </b-col>
                        <b-col cols="8">
                          <b-form-group class="d-inline-block mb-0 ml-3 mr-0">
                            <b-form-radio class="custom-control-inline" v-model="accountingRecordsKept" name="accounting-records-kept" :value="true">kept</b-form-radio>
                            <b-form-radio class="custom-control-inline" v-model="accountingRecordsKept" name="accounting-records-kept" :value="false">not kept</b-form-radio>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="4" class="text-left">
                          accounting records
                        </b-col>
                        <b-col cols="8 ">
                          <b-form-group class="d-inline-block mb-0 ml-3 mr-0" v-if="accountingRecordsKept">
                            <b-form-radio class="custom-control-inline" v-model="accountingRecordsKeptSince" name="accounting-records-kept-since" :value="company.incorporationDate">since incorporation</b-form-radio>
                            <b-form-radio class="custom-control-inline" v-model="accountingRecordsKeptSince" name="accounting-records-kept-since" :value="financialStatementsPreparedUntil" v-if="financialStatementsPrepared">since {{ financialStatementsPreparedUntil }}</b-form-radio>
                          </b-form-group>

                          <b-form-group class="d-inline-block mb-0 ml-3 mr-0" v-if="!accountingRecordsKept">
                            <b-form-radio class="custom-control-inline" v-model="accountingRecordsNotKeptSince" name="accounting-records-kept-since" :value="company.incorporationDate">since incorporation</b-form-radio>
                            <b-form-radio class="custom-control-inline" v-model="accountingRecordsNotKeptSince" name="accounting-records-kept-since" :value="financialStatementsPreparedUntil" v-if="financialStatementsPrepared">since {{ financialStatementsPreparedUntil }}</b-form-radio>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-card-body>
                <b-card-footer>
                  <b-row>
                    <b-col>
                      <b-btn @click="cancel">
                        <i class="fa fa-times mr-2"></i> Cancel
                      </b-btn>
                    </b-col>
                    <b-col class="text-right">
                      <span v-if="!valid" class="text-danger mr-4"
                        >Please complete all required fields.</span
                      >
                      <base-button native-type="submit" :disabled="!valid">
                        <span v-if="!saving">
                          Save document
                          <i class="fa fa-arrow-right ml-2"></i>
                        </span>
                        <span v-else>
                          <i class="fa fa-spin fa-spinner mr-2"></i> Please
                          wait&hellip;
                        </span>
                      </base-button>
                    </b-col>
                  </b-row>
                </b-card-footer>
              </b-form>
            </validation-observer>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import currencies from "currency-codes";
import _ from "underscore";
import moment from "moment";
import { get } from "dot-prop";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import FindOrCreateContactForm from "../../Contacts/FindOrCreateContactForm";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";

export default {
  name: "document-create",
  components: {
    FindOrCreateContactForm,
    RouteBreadCrumb,
    Loading
  },
  props: {
    companyId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      company: null,
      type: "iom_1931_act_limited_by_shares_annual_return",
      filingDueDate: null,
      signatoryId: null,
      signatoryRole: "Director",
      returnDate: moment().format("YYYY-MM-DD"),
      signingDate: moment().format("YYYY-MM-DD"), // Today
      presenterName: "The Company",
      presenterAddress: null,
      // financial statements
      financialStatementsPrepared: true,
      financialStatementsNotRequiredSinceIncorporation: false,
      financialStatementsPreparedUntil: null,
      // accounts
      accountingRecordsKept: true,
      accountingRecordsKeptSince: null,
      accountingRecordsNotKeptSince: null,
      // errors etc.
      errorMessage: null,
      errors: {},
      saving: false,
      loading: false,
      signatoryPresetContact: null
    };
  },
  computed: {
    account: function() {
      return this.$store.state.account;
    }
  },
  watch: {
    signatoryId: function(newVal) {
      // check whether signatory is a director, secretary or not
      const isDirector = _.findWhere(this.company.directors, {
        contactId: newVal,
        isCurrent: true
      });
      const isSecretary = _.findWhere(this.company.secretaries, {
        contactId: newVal,
        isCurrent: true
      });

      if (isDirector) {
        this.signatoryRole = "Director";
      } else if (isSecretary) {
        this.signatoryRole = "Secretary";
      } else {
        this.signatoryRole = "Authorized Signatory";
      }
    }
  },
  created: function() {
    this.loadCompany();
  },
  methods: {
    cancel() {
      // go to company view page
      this.$router.push(`/companies/${this.companyId}`);
    },
    loadCompany() {
      this.loading = true;
      this.axios
        .get(`/v1/accounts/${this.account.id}/companies/${this.companyId}`)
        .then(response => {
          this.loading = false;
          this.company = response.data;

          // figure out a load of other fields based on the company
          if (this.company.nextYearEndDate) {
            // made up to date - one day after year end
            this.returnDate = moment(this.company.nextYearEndDate)
              .add(1, "day")
              .format("YYYY-MM-DD");
            // filing due one month and one day after year end
            this.filingDueDate = moment(this.returnDate)
              .add(1, "month")
              .format("YYYY-MM-DD");

            const previousAccountingPeriodEndDate = moment(
              this.company.nextYearEndDate
            )
              .subtract(1, "year")
              .format("YYYY-MM-DD");

            if (
            moment(this.company.incorporationDate).isAfter(
              previousAccountingPeriodEndDate
            )
            ) {
              // a full accounting period has not passed since company incorporation
              this.financialStatementsPrepared = false;
              this.financialStatementsNotRequiredSinceIncorporation = true;
              this.financialStatementsPreparedUntil = null;
              this.accountingRecordsKept = true;
              this.accountingRecordsKeptSince = this.company.incorporationDate;
              this.accountingRecordsNotKeptSince = this.company.incorporationDate;
            } else {
              this.financialStatementsPrepared = true;
              this.financialStatementsNotRequiredSinceIncorporation = false;
              this.financialStatementsPreparedUntil = previousAccountingPeriodEndDate;
              this.accountingRecordsKept = true;
              this.accountingRecordsKeptSince = previousAccountingPeriodEndDate;
              this.accountingRecordsNotKeptSince = previousAccountingPeriodEndDate;
            }
          }

          if (this.presenterName === "The Company") {
            this.presenterAddress = this.company.address;
          }

          // set a signatory - use the earliest current secretary
          const signatory = _.findWhere(this.company.secretaries, {
            isCurrent: true
          });
          this.signatoryId = signatory.contactId;
          this.signatoryPresetContact = signatory.contact;
        })
        .catch(error => {
          this.loading = false;
          this.errorMessage = "Failed to load comapny";
          if (get(error, "response.data.message")) {
            this.errorMessage = error.response.data.message;
          }
        });
    },
    createDocument: function() {
      const requestBody = {};

      requestBody.type = this.type;
      requestBody.filingDueDate = this.filingDueDate;
      requestBody.signatoryId = this.signatoryId;

      if (this.type === "iom_1931_act_limited_by_shares_annual_return") {
        requestBody.details = {};
        requestBody.details.signatoryRole = this.signatoryRole;
        requestBody.details.returnDate = this.returnDate;
        requestBody.details.signingDate = this.signingDate;
        requestBody.details.presenterName = this.presenterName;
        requestBody.details.presenterAddress = this.presenterAddress;

        // financial statements
        requestBody.details.financialStatementsPrepared = this.financialStatementsPrepared;
        if (this.financialStatementsPrepared) {
          requestBody.details.financialStatementsPreparedUntil = this.financialStatementsPreparedUntil;
        } else {
          requestBody.details.financialStatementsNotRequiredSinceIncorporation = this.financialStatementsNotRequiredSinceIncorporation;
        }

        // accounting records
        requestBody.details.accountingRecordsKept = this.accountingRecordsKept;
        if (this.accountingRecordsKept) {
          requestBody.details.accountingRecordsKeptSince = this.accountingRecordsKeptSince;
        } else {
          requestBody.details.accountingRecordsNotKeptSince = this.accountingRecordsNotKeptSince;
        }
      }

      // send the request
      this.saving = true;
      this.axios
        .post(
          `/v1/accounts/${this.account.id}/companies/${this.companyId}/documents`,
          requestBody
        )
        .then(response => {
          this.saving = false;
          // notify
          this.$notify({
            message: "Document created",
            timeout: 3000,
            icon: "fa fa-check",
            type: "success"
          });

          // go to document view page
          this.$router.push(
            `/companies/${this.company.id}/documents/${response.data.id}`
          );
        })
        .catch(error => {
          this.saving = false;
          this.errorMessage = "Failed to create document";
          if (get(error, "response.data.message")) {
            this.errorMessage = error.response.data.message;
          }
        });
    }
  }
};
</script>
<style>
.starter-page {
  min-height: calc(100vh - 380px);
}
</style>
